import * as React from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { motion } from "framer-motion";
import { signupSchema } from "../../schema/signupSchema";
import AuthLayout from "../../components/auth/AuthLayout";
import StylishInput from "../../components/auth/StylishInput";

const SignupPage = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(signupSchema),
  });

  const onSubmit = (data) => {
    console.log("Signup Data:", data);
    reset();
  };

  return (
    <AuthLayout title="Sign Up">
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <StylishInput
          label="Username"
          type="text"
          register={register("username")}
          error={errors.username}
        />
        <StylishInput
          label="Email"
          type="email"
          register={register("email")}
          error={errors.email}
        />
        <StylishInput
          label="Password"
          type="password"
          register={register("password")}
          error={errors.password}
        />
        <StylishInput
          label="Confirm Password"
          type="password"
          register={register("confirmPassword")}
          error={errors.confirmPassword}
        />
        <motion.button
          whileHover={{ scale: 0.99 }}
          whileTap={{ scale: 0.98 }}
          type="submit"
          className="w-full bg-indigo-600 text-white rounded-lg py-3 font-medium hover:bg-indigo-700 transition shadow-lg"
        >
          Sign Up
        </motion.button>
      </form>
    </AuthLayout>
  );
};

export default SignupPage;
